export default __webpack_public_path__ + "static/media/search-solid.3589b0c8.svg";